import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/767b4790/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentDemo = makeShortcode("ComponentDemo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ComponentDemo links={{
      React: 'http://react.carbondesignsystem.com/?path=/story/codesnippet--inline',
      Angular: 'https://angular.carbondesignsystem.com/?path=/story/components-code-snippet--basic',
      Vue: 'http://vue.carbondesignsystem.com/?path=/story/components-cvcodesnippet--default',
      Vanilla: 'https://the-carbon-components.netlify.com/?nav=code-snippet'
    }} knobs={{
      CodeSnippet: ['type']
    }} mdxType="ComponentDemo">
  {`
<CodeSnippet>
{\`@mixin grid-container {
    width: 100%;
    padding-right: padding(mobile);
    padding-left: padding(mobile);
  
    @include breakpoint(bp--xs--major) {
      padding-right: padding(xs);
      padding-left: padding(xs);
    }
  }
    
  $z-indexes: (
    modal : 9000,
    overlay : 8000,
    dropdown : 7000,
    header : 6000,
    footer : 5000,
    hidden : - 1,
    overflowHidden: - 1,
    floating: 10000
  );\`}
</CodeSnippet>`}
    </ComponentDemo>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      